import React, { Component } from 'react';
import './index.scss';
import { Trans } from 'react-i18next'
import i18n from '../../../i18n'

class PremiumSectionEn extends Component {

    renderItems = () => {
        const items = [
            {
                img: 'https://front.videomonster.com/images-7cuytg20/web/home/premium-section-local-business.png',
                text: i18n.t("web.newhome.premium.section.en.img.text1"),
            },
            {
                img: 'https://front.videomonster.com/images-7cuytg20/web/home/premium-section-ecommerce-business.png',
                text: <Trans i18nKey="web.newhome.premium.section.en.img.text2"><br /></Trans>,
            },
            {
                img: 'https://front.videomonster.com/images-7cuytg20/web/home/premium-section-agency.png',
                text: i18n.t("web.newhome.premium.section.en.img.text3"),
            }
        ]

        return items.map(item => {
            return (
                <div className='img-area'>
                    <div className='img'><img src={item.img} alt=''/></div>
                    <div className='title'>{item.text}</div>
                </div>
            )
        })
    }
    render() {
        return (
            <div className="premium-section-en-root-container">
                <div className='heading'>
                    <Trans i18nKey="web.newhome.premium.section.en.title">
                        <br />
                        <span />
                    </Trans>
                </div>
                <div className='des'>{i18n.t("web.newhome.premium.section.en.des")}</div>
                <div className='premium-section-en-body'>
                    {this.renderItems()}
                    <div className='text'>{i18n.t("web.newhome.premium.section.en.text")}</div>
                </div>
                <div className='bottom-text'>{i18n.t("web.newhome.premium.section.en.bottom.text")}</div>
            </div>
        );
    }
}

export default PremiumSectionEn